module.exports = __webpack_public_path__ + "media/img/event/logo/mtsu-3238b8b889953ba05eb8b724bd681c92.jpg";